module.exports = __webpack_public_path__ + "static/media/181IT202.486196e3.jpeg";